import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { request } from "services/api";

// export default () => {
//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     (async function () {
//       try {
//         setLoading(true);
//         const response = await request.get("seed/getSeed");
//         setData(response.data.data);
//       } catch (err) {
//         setError(err);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   return { data, error, loading };
// };

export default () =>
  useQuery(["seedList"], async () => {
    const response = await request.get("seed/getSeed");
    if (response.data.success) {
      return response.data.data;
    }

    return [];
  });
